const CustomSpinner = ({ cls = "text-light" }) => (
	<div className={`spinner-border ${cls}`} role="status">
		<span className="visually-hidden">Loading...</span>
	</div>
);

export default CustomSpinner;
